<template>
  <table class="l-form-table">
    <tr>
      <th class="v-middle"><span>監査表示する企業</span></th>
      <td>
        <template v-if="responsibleCorporates.length > 0">
          <label class="l-checkbox">
            <input type="checkbox" name="checkbox" v-model="isAllChecked" @click="changeIsAllChecked(!isAllChecked)"> すべて
          </label><br>
          <label class="l-checkbox" v-for="(responsibleCorporate, index) in responsibleCorporates" :key=index>
            <input type="checkbox"
              @change="inputResponsibleCorporates"
              class="target-checkbox"
              :value="responsibleCorporate.corpId"
              v-model="responsibleCorporateIds"
              :disabled="isAllResponsibleCorporate" />
            {{ responsibleCorporate.corpNm }}
          </label>
        </template>
      </td>
    </tr>
  </table>
</template>

<script>

export default {
  components: {
  },
  props: {
    responsibleCorporates: [],
    isNew: {
      'default': false,
    },
  },
  data() {
    return {
      responsibleCorporateIds: [],
      isAllResponsibleCorporate: false,
    }
  },
  computed: {
    isAllChecked() {
      return this.responsibleCorporateIds.length == this.responsibleCorporates.length;
    }
  },
  watch: {
    isAllChecked() {
      this.isAllResponsibleCorporate = this.isAllChecked;
    }
  },
  created() {
    let responsibleCorporateIds = [];
    const isNew = this.isNew;
    this.responsibleCorporates.forEach(c => {
      // 新規登録時には全チェック済の状態にしておく
      if (c.responsibleCorporateId || isNew) {
        responsibleCorporateIds.push(c.corpId);
      }
    }, isNew);
    this.responsibleCorporateIds = responsibleCorporateIds;
  },
  methods: {
    inputResponsibleCorporates(params) {
      if (params.checked) {
        this.responsibleCorporateIds.push(params.value);
      } else {
        this.responsibleCorporateIds = this.responsibleCorporateIds.filter(v => v != params.value);
      }
      this.$emit("change-responsible-corporates", {
        responsibleCorporateIds: this.responsibleCorporateIds,
      });
    },
    changeIsAllChecked(value) {
      if (value) {
        this.responsibleCorporateIds = this.responsibleCorporates.map(corp => corp.corpId);
      } else {
        this.isAllResponsibleCorporate = false;
      }
      this.$emit("change-responsible-corporates", {
        responsibleCorporateIds: this.responsibleCorporateIds,
      });
    },
  }
}

</script>
